module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login py-5"
  }, [_c('div', {
    attrs: {
      "id": "firebaseui-auth-container"
    }
  }), _vm._v(" "), (_vm.logged) ? _c('div', {
    staticClass: "alert alert-success col-6 offset-3 my-5"
  }, [_vm._v("\n    Du bist eingeloggt.\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f224345"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 712
// module chunks = 1